var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('v-button',{directives:[{name:"tooltip",rawName:"v-tooltip:auto",value:(_vm.content),expression:"content",arg:"auto"}],staticClass:"shorten"},[_vm._v("\n    "+_vm._s(_vm.content)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }